module.exports = __webpack_public_path__ + "img/图1-20三角板的用法.3e6e9d6f.png";